import _styled from '@emotion/styled/base';
import 'react';
import { BsPlus } from '@react-icons/all-files/bs/BsPlus';
import 'use-context-selector';
import { jsx } from '@emotion/react';
import '../../contexts/internal/StickyContext.js';
import '../../contexts/internal/EditorContext.js';
import '../../components/Canvas/Canvas.style.js';
import '../../components/Canvas/PreviewModeContainer.js';
import '../../components/Duration/DurationInput.js';
import 'react-hook-form';
import '../../components/FieldItem.js';
import '../../components/FormGroup/FormGroup.js';
import '../../components/FormGroup/LogDataFormGroup.js';
import '../../components/Header/index.js';
import '../../components/Input/ColorPickerField/index.js';
import '../../components/Input/URLInput.js';
import '../../components/Inspector/Inspector.js';
import '../../components/TreeList/TreeList.style.js';
import '@react-icons/all-files/hi/HiChevronDown';
import '@react-icons/all-files/hi/HiChevronRight';
import '@react-icons/all-files/ri/RiCloseCircleFill';
import '@react-icons/all-files/ri/RiDeleteBinLine';
import '@react-icons/all-files/ri/RiFileCopyLine';
import '@react-icons/all-files/ri/RiShapeLine';
import 'qs';
import 'query-string';
import '@react-icons/all-files/md/MdLens';
import 'lodash-es';
import '@bucketplace/ui';
import '@bucketplace/bucket-log';
import 'react-dom';
import '../../components/Tooltip/Tooltip.js';
import '../../components/Toolbar/Toolbar.style.js';
import '../../components/TreeList/Draggable.js';
import { EditorPlaceholder } from '../../components/EditorPlaceholder/EditorPlaceholder.js';
import '../../components/FormContent.js';

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function HTMLTemplate(_ref) {
  var contents = _ref.contents;
  if (!contents) {
    return jsx(EditorPlaceholder, {
      icon: jsx(BsPlus, null),
      message: "\uB0B4\uC6A9\uC744 \uCD94\uAC00\uD574\uC8FC\uC138\uC694."
    });
  }
  return jsx(Template, {
    dangerouslySetInnerHTML: {
      __html: contents
    }
  });
}
var Template = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eahpyel0"
} : {
  target: "eahpyel0",
  label: "Template"
})(process.env.NODE_ENV === "production" ? {
  name: "q7v2fn",
  styles: "*{width:100%;display:inherit;}"
} : {
  name: "q7v2fn",
  styles: "*{width:100%;display:inherit;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkhUTUxUZW1wbGF0ZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMEIyQiIsImZpbGUiOiJIVE1MVGVtcGxhdGUudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IFByb3BzV2l0aENoaWxkcmVuLCBSZWFjdEVsZW1lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBCc1BsdXMgfSBmcm9tICdAcmVhY3QtaWNvbnMvYWxsLWZpbGVzL2JzL0JzUGx1cyc7XG5cbmltcG9ydCB7IEVkaXRvclBsYWNlaG9sZGVyIH0gZnJvbSAnLi4vLi4vY29tcG9uZW50cyc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgSFRNTFRlbXBsYXRlUHJvcHMge1xuICAvKiogSFRNTOuhnCDrkJwg64K07JqpICovXG4gIGNvbnRlbnRzOiBzdHJpbmc7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBIVE1MVGVtcGxhdGUoeyBjb250ZW50cyB9OiBQcm9wc1dpdGhDaGlsZHJlbjxIVE1MVGVtcGxhdGVQcm9wcz4pOiBSZWFjdEVsZW1lbnQge1xuICBpZiAoIWNvbnRlbnRzKSB7XG4gICAgcmV0dXJuIChcbiAgICAgIDxFZGl0b3JQbGFjZWhvbGRlclxuICAgICAgICBpY29uPXs8QnNQbHVzIC8+fVxuICAgICAgICBtZXNzYWdlPVwi64K07Jqp7J2EIOy2lOqwgO2VtOyjvOyEuOyalC5cIlxuICAgICAgLz5cbiAgICApO1xuICB9XG5cbiAgcmV0dXJuIChcbiAgICA8VGVtcGxhdGUgZGFuZ2Vyb3VzbHlTZXRJbm5lckhUTUw9e3sgX19odG1sOiBjb250ZW50cyB9fSAvPlxuICApO1xufVxuXG5jb25zdCBUZW1wbGF0ZSA9IHN0eWxlZC5kaXZgXG4gICoge1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIGRpc3BsYXk6IGluaGVyaXQ7XG4gIH1cbmA7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export { HTMLTemplate };
//# sourceMappingURL=HTMLTemplate.js.map
